/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "дирӯз",
        "0": "имрӯз",
        "1": "фардо",
        "future": {
          "other": "пас аз {0} рӯз"
        },
        "past": {
          "other": "{0} рӯз пеш"
        }
      },
      "day-narrow": {
        "-1": "дирӯз",
        "0": "имрӯз",
        "1": "фардо",
        "future": {
          "other": "пас аз {0} рӯз"
        },
        "past": {
          "other": "{0} рӯз пеш"
        }
      },
      "day-short": {
        "-1": "дирӯз",
        "0": "имрӯз",
        "1": "фардо",
        "future": {
          "other": "пас аз {0} рӯз"
        },
        "past": {
          "other": "{0} рӯз пеш"
        }
      },
      "hour": {
        "0": "соати ҷорӣ",
        "future": {
          "other": "пас аз {0} соат"
        },
        "past": {
          "other": "{0} соат пеш"
        }
      },
      "hour-narrow": {
        "0": "соати ҷорӣ",
        "future": {
          "other": "пас аз {0} ст."
        },
        "past": {
          "other": "{0} ст. пеш"
        }
      },
      "hour-short": {
        "0": "соати ҷорӣ",
        "future": {
          "other": "пас аз {0} ст."
        },
        "past": {
          "other": "{0} ст. пеш"
        }
      },
      "minute": {
        "0": "дақиқаи ҷорӣ",
        "future": {
          "other": "пас аз {0} дақиқа"
        },
        "past": {
          "other": "{0} дақиқа пеш"
        }
      },
      "minute-narrow": {
        "0": "дақиқаи ҷорӣ",
        "future": {
          "other": "пас аз {0} дақ."
        },
        "past": {
          "other": "{0} дақ. пеш"
        }
      },
      "minute-short": {
        "0": "дақиқаи ҷорӣ",
        "future": {
          "other": "пас аз {0} дақ."
        },
        "past": {
          "other": "{0} дақ. пеш"
        }
      },
      "month": {
        "-1": "моҳи гузашта",
        "0": "моҳи ҷорӣ",
        "1": "моҳи оянда",
        "future": {
          "other": "пас аз {0} моҳ"
        },
        "past": {
          "other": "{0} моҳ пеш"
        }
      },
      "month-narrow": {
        "-1": "моҳи г.",
        "0": "моҳи ҷ.",
        "1": "моҳи о.",
        "future": {
          "other": "пас аз {0} м."
        },
        "past": {
          "other": "{0} м. пеш"
        }
      },
      "month-short": {
        "-1": "моҳи г.",
        "0": "моҳи ҷ.",
        "1": "моҳи о.",
        "future": {
          "other": "пас аз {0} м."
        },
        "past": {
          "other": "{0} м. пеш"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "чоряки гузашта",
        "0": "чоряки ҷорӣ",
        "1": "чоряки оянда",
        "future": {
          "other": "пас аз {0} чоряк"
        },
        "past": {
          "other": "{0} чоряк пеш"
        }
      },
      "quarter-narrow": {
        "-1": "чоряки гузашта",
        "0": "чоряки ҷорӣ",
        "1": "чоряки оянда",
        "future": {
          "other": "пас аз {0} чр."
        },
        "past": {
          "other": "{0} чр. пеш"
        }
      },
      "quarter-short": {
        "-1": "чоряки гузашта",
        "0": "чоряки ҷорӣ",
        "1": "чоряки оянда",
        "future": {
          "other": "пас аз {0} чр."
        },
        "past": {
          "other": "{0} чр. пеш"
        }
      },
      "second": {
        "0": "ҳозир",
        "future": {
          "other": "пас аз {0} сония"
        },
        "past": {
          "other": "{0} сония пеш"
        }
      },
      "second-narrow": {
        "0": "ҳозир",
        "future": {
          "other": "пас аз {0} сон."
        },
        "past": {
          "other": "{0} сон. пеш"
        }
      },
      "second-short": {
        "0": "ҳозир",
        "future": {
          "other": "пас аз {0} сон."
        },
        "past": {
          "other": "{0} сон. пеш"
        }
      },
      "week": {
        "-1": "ҳафтаи гузашта",
        "0": "ҳафтаи ҷорӣ",
        "1": "ҳафтаи оянда",
        "future": {
          "other": "пас аз {0} ҳафта"
        },
        "past": {
          "other": "{0} ҳафта пеш"
        }
      },
      "week-narrow": {
        "-1": "ҳафтаи г.",
        "0": "ҳафтаи ҷ.",
        "1": "ҳафтаи о.",
        "future": {
          "other": "пас аз {0} ҳ."
        },
        "past": {
          "other": "{0} ҳ. пеш"
        }
      },
      "week-short": {
        "-1": "ҳафтаи г.",
        "0": "ҳафтаи ҷ.",
        "1": "ҳафтаи о.",
        "future": {
          "other": "пас аз {0} ҳ."
        },
        "past": {
          "other": "{0} ҳ. пеш"
        }
      },
      "year": {
        "-1": "соли гузашта",
        "0": "соли ҷорӣ",
        "1": "соли оянда",
        "future": {
          "other": "пас аз {0} сол"
        },
        "past": {
          "other": "{0} сол пеш"
        }
      },
      "year-narrow": {
        "-1": "соли г.",
        "0": "соли ҷ.",
        "1": "соли о.",
        "future": {
          "other": "пас аз {0} с."
        },
        "past": {
          "other": "{0} с. пеш"
        }
      },
      "year-short": {
        "-1": "соли г.",
        "0": "соли ҷ.",
        "1": "соли о.",
        "future": {
          "other": "пас аз {0} с."
        },
        "past": {
          "other": "{0} с. пеш"
        }
      }
    },
    "locale": "tg"
  });
}